/** Форматирование значений интерфейса Кадров (даты, деньги, числа). */

const dateFmt = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFmt = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const moneyFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });

/** «23.09.2026»; пустое значение — «—». */
export function kadryDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateFmt.format(d);
}

/** «23.09.2026, 14:05»; пустое значение — «—». */
export function kadryDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateTimeFmt.format(d);
}

/** «150 000 ₽»; пустое значение — «—». */
export function kadryMoney(rub: number | null | undefined): string {
  if (rub == null) return '—';
  return `${moneyFmt.format(rub)} ₽`;
}

/** Диапазон оплаты: «от 90 000 до 150 000 ₽», «до 120 000 ₽», «—». */
export function kadryPayRange(from: number | null | undefined, to: number | null | undefined): string {
  if (from == null && to == null) return '—';
  if (from != null && to != null) return `от ${moneyFmt.format(from)} до ${moneyFmt.format(to)} ₽`;
  if (from != null) return `от ${moneyFmt.format(from)} ₽`;
  return `до ${moneyFmt.format(to as number)} ₽`;
}

/** Период повтора поиска по умолчанию, ч (как на сервере). */
export const KADRY_DEFAULT_SCHEDULE_HOURS = 12;

/**
 * Не больше стольких запросов API hh в сутки тратит одна активная заявка при
 * повторе поиска раз в `hours` ч (`perRun` — максимум за прогон).
 */
export function kadrySearchDailyMax(perRun: number, hours: number): number {
  return Math.ceil((perRun * 24) / hours);
}

/** Склонение: `kadryPlural(5, ['день', 'дня', 'дней'])` → «дней». */
export function kadryPlural(n: number, forms: readonly [string, string, string]): string {
  const a = Math.abs(n) % 100;
  const b = a % 10;
  if (a > 10 && a < 20) return forms[2];
  if (b > 1 && b < 5) return forms[1];
  if (b === 1) return forms[0];
  return forms[2];
}
